import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-bild-entfernen';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenAufgabeBildEntfernenEffects {

    AufgabeBildEntfernen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_BILD_ENTFERNEN),
        mergeMap((x: ac.PostAufgabeBildEntfernenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeBildEntfernen(x.aufgabeBildRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeBildEntfernenErfolgreichAction(result, x.aufgabeBildRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeBildEntfernenFehlerAction(error, x.aufgabeBildRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AufgabenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AufgabenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.AufgabenCommandService);
        }
        return this.service;
    }
}
